import { createContext, useContext } from "react";
export var MultiSelectFilterContext = createContext(null);
export var useMultiSelectFilterContext = function () {
    var context = useContext(MultiSelectFilterContext);
    if (context === null) {
        throw new Error("Ce composant nécessite l'utilisation du contexte MultiSelectFilterContext");
    }
    return context;
};
